import { Event } from "../../contracts";

export const mapIsSelected = (event: Event, activeEventId: string) => {
    event.isSelected = event.id === activeEventId;
    return event;
}